module.exports = __webpack_public_path__ + "img/a064f11b5f2716c3559b527328fd29dd.png";